// EnterLink.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateEventPage.css"; // Import the new stylesheet

const EnterLink = () => {
  const [link, setLink] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!link.trim()) {
      alert("⚠️ Please enter a valid URL!");
      return;
    }

    // Navigate to QrGenerator with link passed in state
    navigate("/QrGenerator/custom", { state: { url: link.trim() } });
  };

  return (
    <div className="form-page-container">
      <div className="form-panel">
        <h1 className="form-title">Generate a QR Code</h1>
        <p className="form-subtitle">Enter any URL to create a scannable QR code.</p>
        <form onSubmit={handleSubmit} className="form-content">
          <input
            type="url"
            placeholder="https://example.com"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="form-input"
            required
          />
          <button type="submit" className="form-button">
            Generate QR
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnterLink;